import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const TabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigationItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      path: '/shared-profile-dashboard',
      icon: 'LayoutDashboard'
    },
    {
      id: 'communicate',
      label: 'Communicate',
      path: '/ai-communication-hub',
      icon: 'MessageCircle'
    },
    {
      id: 'mood',
      label: 'Mood',
      path: '/mood-tracker',
      icon: 'Heart'
    },
    {
      id: 'schedule',
      label: 'Schedule',
      path: '/intimacy-scheduler',
      icon: 'Calendar'
    },
    {
      id: 'analytics',
      label: 'Analytics',
      path: '/ai-analytics-dashboard',
      icon: 'BarChart3'
    },
    {
      id: 'history',
      label: 'History',
      path: '/encounter-management',
      icon: 'Clock'
    },
    {
      id: 'settings',
      label: 'Settings',
      path: '/profile-settings',
      icon: 'Settings'
    }
  ];

  const isActive = (path) => {
    return location?.pathname === path;
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-navigation bg-card border-b border-border hidden lg:block">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-[60px]">
            <div className="flex items-center space-x-2">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-md">
                <Icon name="Heart" size={24} color="var(--color-primary)" />
              </div>
              <span className="text-xl font-heading font-semibold text-foreground">
                LoveNudge
              </span>
            </div>

            <div className="flex items-center space-x-1">
              {navigationItems?.map((item) => (
                <button
                  key={item?.id}
                  onClick={() => handleNavigation(item?.path)}
                  className={`
                    flex items-center space-x-2 px-4 py-2 rounded-md
                    transition-therapeutic font-medium text-sm
                    ${isActive(item?.path)
                      ? 'bg-primary text-primary-foreground'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    }
                  `}
                >
                  <Icon 
                    name={item?.icon} 
                    size={20} 
                    color={isActive(item?.path) ? 'var(--color-primary-foreground)' : 'currentColor'}
                  />
                  <span>{item?.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </nav>
      <nav className="fixed bottom-0 left-0 right-0 z-navigation bg-card border-t border-border lg:hidden">
        <div className="flex items-center justify-around h-[56px] px-2">
          {navigationItems?.map((item) => (
            <button
              key={item?.id}
              onClick={() => handleNavigation(item?.path)}
              className={`
                flex flex-col items-center justify-center space-y-1 px-3 py-2 rounded-md
                transition-therapeutic min-w-[64px]
                ${isActive(item?.path)
                  ? 'text-primary' :'text-muted-foreground'
                }
              `}
            >
              <Icon 
                name={item?.icon} 
                size={22} 
                color={isActive(item?.path) ? 'var(--color-primary)' : 'currentColor'}
              />
              <span className="text-xs font-caption font-medium">
                {item?.label}
              </span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default TabNavigation;